@if (visible()) {
  <nav class="sas-breadcrumb" aria-label="breadcrumb">
    @for (item of items(); track $index) {
      @if ($index > 0) {
        <span class="sas-breadcrumb__sep" aria-hidden="true">/</span>
      }
      @if (item.url) {
        <a [routerLink]="item.url">{{ item.label }}</a>
      } @else {
        <span class="sas-breadcrumb__current" aria-current="page">{{ item.label }}</span>
      }
    }
  </nav>
}